// extracted by mini-css-extract-plugin
export default {"container":"EN0eBCKJ2yKOvWhV8pbE","text":"adZkrtJfp8l9JcjbBwW3"};